import { Grid } from "@material-ui/core";
import React from "react";
import i18next from "../../../../assets/i18n/i18n";
import "./change-account.scss";

export default class ChangeAccount extends React.Component<any> {
    render(): React.ReactElement {
        return (
            <Grid container style={{ marginTop: "2em" }}>
                <Grid item xs={12} className="change-account-header">
                    {i18next.t("ChangeAccount.Header")}
                </Grid>
                <Grid item xs={12} className="change-account-infotext">
                    {i18next.t("ChangeAccount.InfoText")}
                </Grid>
                <Grid item xs={12} className="change-account-infotext">
                    {i18next.t("ChangeAccount.Warning")}
                </Grid>
            </Grid>
        );
    }
}
